import React, { Component } from "react";

import { Form } from "components";

class CustomForm extends Component {
  state = {
    data: this.props.data,
    languages: [
      { value: "pt-BR", label: "Português" },
      { value: "en", label: "Inglês" },
      { value: "es", label: "Espanhol" }
    ]
  };

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { onChange } = this.props;

    if (oldProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleChangeInput = e => {
    const { data } = this.state;
    const { name, value } = e.target;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleChangeCPF = value => {
    const { data } = this.state;

    this.setState({ data: { ...data, cpf: value } });
  };

  handleChangeLocale = value => {
    const { data } = this.state;

    this.setState({ data: { ...data, locale: value } });
  };

  render() {
    const { data, languages } = this.state;
    const { errors } = this.props;

    return (
      <Form onSubmit={this.onSubmit}>
        <div className="row">
          <div className="col-6">
            <Form.Group>
              <Form.Label>Nome</Form.Label>
              <Form.Input
                name="name"
                placeholder="Nome Completo"
                value={data.name}
                onChange={this.handleChangeInput}
                errors={errors.name}
                focus={1}
              />
            </Form.Group>
          </div>

          <div className="col-6">
            <Form.Group>
              <Form.Label>E-mail</Form.Label>
              <Form.Input
                name="email"
                placeholder="E-mail"
                value={data.email}
                onChange={this.handleChangeInput}
                errors={errors.email}
              />
            </Form.Group>
          </div>

          <div className="col-6">
            <Form.Group>
              <Form.Label>Idioma</Form.Label>
              <Form.Select
                placeholder="Selecione o idioma do participante"
                noOptionsMessage={() => "Idioma não encontrado"}
                options={languages}
                value={data.locale}
                errors={errors.locale}
                onChange={this.handleChangeLocale}
              />
            </Form.Group>
          </div>
        </div>
      </Form>
    );
  }
}

export default CustomForm;



// WEBPACK FOOTER //
// ./src/pages/Admin/Participants/components/Form/index.js